module.exports = {
      id: "banners-usage",
      viewBox: "0 0 445.6 352.1",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#banners-usage",
      toString: function () {
        return this.url;
      }
    }